import { render, staticRenderFns } from "./PcNews4.vue?vue&type=template&id=2913f983&scoped=true"
import script from "./PcNews4.vue?vue&type=script&lang=js"
export * from "./PcNews4.vue?vue&type=script&lang=js"
import style0 from "./PcNews4.vue?vue&type=style&index=0&id=2913f983&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2913f983",
  null
  
)

export default component.exports